import { JsonSerializable } from '@/util/object/JsonSerializable'

export class OrderValidationRulesResponse extends JsonSerializable {
  /** @type {Array<string>} */
  #blacklistedEmailDomains // TODO jsawyer - Name should be changed

  constructor (jsonObject) {
    super()
    this.#blacklistedEmailDomains = jsonObject.blacklistedEmailDomains || []
    Object.freeze(this)
  }

  /**
   * Email domains that are blacklisted
   * @return {Array<string>}
   */
  get blacklistedEmailDomains () {
    return this.#blacklistedEmailDomains
  }

  /**
   * @return {Object}
   */
  toJSON () {
    return { blacklistedEmailDomains: this.#blacklistedEmailDomains }
  }

  /**
   * @param {Object} jsonObject
   * @return {OrderValidationRulesResponse|undefined}
   */
  static fromJSON (jsonObject) {
    return (jsonObject && new OrderValidationRulesResponse(jsonObject)) || undefined
  }
}
